<template>
  <div style="background-color: #fafaf5; min-height: 100vh; overflow: scroll">
    <div
      class="top_bg"
      style="background-image: url('img/luckyCoin/top_bg.png')"
    >
      <div
        class="go_back_button"
        @click="goBack"
        style="background-image: url('img/luckyCoin/back.png')"
      ></div>
      <div
        class="bronze_bag_"
        style="background-image: url('img/luckyCoin/list_bg.png')"
      >
        <div class="list_content">
          <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <van-list
              v-model="loading"
              :finished="finished"
              finished-text="没有更多了"
              @load="getInfo"
              offset="10"
            >
              <div class="list_box">
                <div
                  class="gift_item_"
                  style="background-image: url('img/luckyCoin/level_high.png')"
                  v-for="(item, index) in listData"
                  :key="index"
                >
                  <div style="display: flex">
                    <img class="send_face" :src="item.head_portrait" alt="" />
                    <div class="nickname">{{ item.nickname }}</div>
                  </div>
                  <div
                    style="
                      display: flex;
                      align-items: center;
                      position: relative;
                    "
                  >
                    <div>
                      <div
                        style="
                          display: flex;
                          justify-content: center;
                          align-items: center;
                        "
                      ></div>
                      <div
                        style="
                          display: flex;
                          align-items: center;
                          justify-content: center;
                          margin-top: 5px;
                        "
                      >
                      <div class="gift_value">
                          获得了
                        </div>
                        <div class="gift_value">
                          {{ item.diamonds }}
                        </div>
                      </div>
                    </div>

                    <img
                      v-if="item.diamonds <10"
                      class="coin"
                      src="img/luckyCoin/1_coin.png"
                      alt=""
                    />
                    <img
                      v-if="item.diamonds>10&&item.diamonds<100"
                      class="coin"
                      src="img/luckyCoin/10_coin.png"
                      alt=""
                    />
                    <img
                      v-if="item.diamonds>=100&&item.diamonds<500"
                      class="coin"
                      src="img/luckyCoin/100_coin.png"
                      alt=""
                    />
                    <img
                      v-if="item.diamonds>=500&&item.diamonds<1000"
                      class="coin"
                      src="img/luckyCoin/1000_coin.png"
                      alt=""
                    />
                    <img
                      v-if="item.diamonds>=1000&&item.diamonds<5000"
                      class="coin"
                      src="img/luckyCoin/10000_coin.png"
                      alt=""
                    />
                    <img
                      v-if="item.diamonds >= 5000"
                      class="coin"
                      src="img/luckyCoin/100000_coin.png"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </van-list>
          </van-pull-refresh>
        </div>
      </div>
    </div>
  </div>
</template>
    <script>
import "@/assets/css/luckyCoin.css";
import { starPlanInfo, serverPullMsg } from "@/api/api";
export default {
  data() {
    return {
      listData: [],
      loading: false,
      finished: false,
      refreshing: false,
      params: {
        type: 3,
        page: 1,
        rows: 15,
        gift_id: 1,
      },
    };
  },
  created() {
    this.getNav();
  },
  methods: {
    getInfo() {
      serverPullMsg(this.params)
        .then(
          (res) => {
            this.loading = false;
            this.refreshing = false;
            if (this.params.page == 1) {
              this.listData = res.data;
            } else {
              this.listData = this.listData.concat(res.data);
            }
            if (res.data.length < 15) {
              this.finished = true;
            } else {
              this.finished = false;
            }
            console.log(this.listData);
            this.params.page = this.params.page + 1;
          },
          (error) => {
            this.$toast.fail(error);
          }
        )
        .catch((error) => {
          this.$toast.fail(error);
        });
    },
    getNav() {
      let params = {
        type: 1,
      };
      starPlanInfo(params).then((res) => {
        for (var i = 0; i < this.ranklist.length; i++) {
          for (var a = 0; a < res.data.data.length; a++) {
            if (res.data.data[a].bag_name == this.ranklist[i].name) {
              this.ranklist[i].show = true;
            }
          }
        }
      });
    },
    onRefresh() {
      this.listData = [];
      this.params.page = 1;
      this.finished = false;
      // this.getInfo();
    },
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>
